import React from 'react';

import "./QuestionList.css";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faInfo} from "@fortawesome/free-solid-svg-icons";

const QuestionListGuessNumber = ({clsHidden, draftActiveProject, questionIndex, handleQuestionInputChange, handleQuestionExpectedAnswersChange}) => {

  return (
    <div className={`form-question-section ${clsHidden}`}>
      <div className="form-row">
        <div className="form-group col-12">
          <label className="form-label" htmlFor="js-form-guess-number-question">Question</label>

          <input
            type="text"
            className="form-control form-input"
            id="js-form-guess-number-question"
            placeholder="e.g: How many lines of code did it take me to automate the network?"
            name="description"
            value={draftActiveProject.questions[questionIndex].description}
            onChange={handleQuestionInputChange(questionIndex)}
          >
          </input>
        </div>
      </div>

      <div className="form-row">
        <div className="form-group col-12">
          <label className="form-label" htmlFor="js-form-guess-number-answer">
            <div>Answer</div>
          </label>
          <div className="row form-row align-items-center">
            <div className="col-12 col-lg-5">
              <div className="d-flex">
                <div style={{paddingTop:"0.3em",whiteSpace:"nowrap"}}>The actual amount is&nbsp;</div>
                <div style={{flexGrow:1}}>
                  <input
                    type="number"
                    step="1"
                    className="form-control form-input"
                    id="js-form-guess-number-answer"
                    placeholder="e.g: 1"
                    name="expected_answer"
                    value={draftActiveProject.questions[questionIndex].expected_answers[0].data}
                    onChange={handleQuestionExpectedAnswersChange}
                  />
                </div>
              </div>
            </div>
            <div className="col-12 col-lg-7 font-small font-italic mt-3 mt-lg-0">
              *
              &nbsp;
              Person who is the closest to this number wins
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default QuestionListGuessNumber;
